// extracted by mini-css-extract-plugin
export default {"Drawer-icons--wrapper":"DrawerSocialIcons_Drawer-icons--wrapper__qFLCZ"};